<template>
  <div id="header">
    <div class="left">
      <a href="/">
        <img src="https://storage.googleapis.com/wcam-27caf.appspot.com/public/logo100.png" style="height: 5vh">
      </a>
    </div>
    <div class="right">
      <span v-show="menu['installMobile']">
        <SettingButton icon="install_mobile"/>
        <separator/>
      </span>
      <span v-show="menu['audio']">
        <SettingButton :icon=" mute ? 'volume_off' : 'volume_up'" @button-click="onVolumeClick"/>
      </span>
      <span v-show="menu['videoRecord'] && !isMobile">
        <separator/>
        <SettingButton icon="save" label="録画して保存"/>
      </span>
      <span v-show="menu['videoMode'] && !isMobile">
        <separator/>
        <SettingButton icon="video_camera_front"/>
        <select class="camera-select" :value="cameraMode" @change="onCameraModeChange">
          <option class="camera-options" value="RAW">実写</option>
          <option class="camera-options" value="FACE_MASK">顔マスク</option>
          <option class="camera-options" value="FIGURE">ピクトグラム</option>
        </select>
      </span>
    </div>
  </div>
</template>

<script>
import SettingButton from "./SettingButton";
import Separator from "./Separator";
import {FitUtil} from "./common/FitUtil";
export default {
  name: "CommonHeader",
  props: {
    menu: {
      type: Object,
    },
    mute: {
      type: Boolean,
    },
    cameraMode: {
      type: String,
    },
  },
  data() {
    return {
      isMobile: FitUtil.isMobile()
    }
  },
  methods: {
    onCameraModeChange(e) {
      this.$emit('camera-mode-change', e.target.value);
    },
    onVolumeClick(e) {
      this.$emit('button-clicked', 'volume')
    },
    onSettingsClick(e) {
      this.$emit('button-clicked', 'settings')
    },
  },
  components: {Separator, SettingButton}
}
</script>

<style scoped>

.camera-select {
  font-size: 2vh;
  margin-left: -10px;
  border: 1px solid #efa118;
  color: #e74a23;
  padding: 4px;
}
.camera-options {
  border: 0;
}
#header {
  position: absolute;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  width: 100vw;
  /*height: 6vh;*/
  height: 8vh;
  line-height: 8vh;
  font-family: 'Hubballi', cursive;
  font-size: 3.5vh;
  background: #f0f0f0;
  /*border-bottom: 4px solid #e74a23;*/
  box-sizing: content-box;

  box-shadow: -8px 8px 16px #ddd;
}
#header .left {
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  box-sizing: content-box;
  width: 30vw;
  text-align: left;
  padding-top: 1.5vh;
  padding-left: 2vw;
  display: inline-block;
}
#header .left a {
  text-decoration: none;
  line-height: 6vh;
  color: #2c3e50;
  font-size: 3vh;
}
#header .right {
  position: absolute;
  top: 0;
  right: 0;
  height: 6vh;
  line-height: 6vh;
  box-sizing: content-box;
  margin: 0;
  width: 70vw;
  font-size: 3.5vh;
  text-align: right;
  padding-right: 2vw;
  display: inline-block;
  z-index: 2;
}
.menu-button {
  display: inline-block;
  font-size: 2vh;
  background: #fff;
  padding: 0.5vh 1vw;
  vertical-align: middle;
  box-sizing: content-box;
  margin: 0;
  border-radius: 4px;
  cursor: pointer;
  height: 3vh;
  line-height: 3vh;
}
.material-icons-outlined {
  vertical-align: middle;
  display: inline;
  font-family: 'Material Icons';
  font-size: 3.5vh;
  line-height: 1;
  /*height: 6vh;*/
  /*line-height: 6vh;*/
}
</style>



// WEBPACK FOOTER //
// src/components/CommonHeader.vue